import React, { useState, useCallback, useContext, useMemo } from 'react';
import useAccountRoles from '@ubeya/shared/hooks/account/useAccountRoles';
import DropDown from '../../DropDown';
import CheckBox from '../../CheckBox';
import FilterLayout from '../FilterLayout';
import ConfigContext from '../../../contexts/ConfigContext';

const AccountRoleFilter = ({ defaultValue, handleClose, onApply, onChange, search, hideLayout = false }) => {
  const { t } = useContext(ConfigContext);
  const { accountRoles } = useAccountRoles();

  const accountRolesOptions = accountRoles.map(({ id, name }) => ({
    value: id,
    label: name
  }));

  const accountRolesOptionsWithCustom = useMemo(() => [...accountRolesOptions, { value: -1, label: t('custom') }], [
    accountRolesOptions,
    t
  ]);

  const [values, setValues] = useState(defaultValue || []);

  const handleChange = useCallback(
    (value) => {
      const newValues = values.includes(value) ? values.filter((item) => item !== value) : [...values, value];
      setValues(newValues);
      onChange?.(newValues);
    },
    [onChange, values]
  );

  const filteredOptions = useMemo(
    () =>
      search
        ? accountRolesOptionsWithCustom.filter(
            ({ label }) =>
              t('adminRole').toLowerCase().includes(search.toLowerCase()) ||
              label.toLowerCase().includes(search.toLowerCase())
          )
        : accountRolesOptionsWithCustom,
    [accountRolesOptionsWithCustom, search, t]
  );

  if (!filteredOptions.length) {
    return null;
  }

  return (
    <FilterLayout
      name={t('adminRole')}
      handleClose={handleClose}
      onApply={() => onApply(values)}
      hideLayout={hideLayout}>
      {filteredOptions.map(({ value, label }) => (
        <DropDown.Item key={value}>
          <CheckBox
            useTextWithTooltip
            name={`adminRole-${value}`}
            value={values.includes(value)}
            label={label}
            onChange={() => handleChange(value)}
          />
        </DropDown.Item>
      ))}
    </FilterLayout>
  );
};

export default AccountRoleFilter;
